import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { take } from 'rxjs';
import { TruncatePipe } from '../../basic/pipes/truncate.pipe';
import { Goal, GoalSubData } from '../../core/goal/goal';
import { ResumeService } from '../../core/resume/resume.service';
import { NewEditGoalComponent } from '../../domain/goal/new-edit-goal/new-edit-goal.component';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';
import { GoalService } from './../../core/goal/goal.service';

@Component({
  selector: 'app-interview-goal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,

    TruncatePipe,

    MatTooltip,

    NewEditGoalComponent,
    InterviewSidebarComponent,
  ],
  templateUrl: './interview-goal.component.html',
  styleUrl: './interview-goal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterviewGoalComponent {
  goalSubData?: GoalSubData;
  selectedGoal?: Goal;

  isNewEditGoalVisible = false;

  isEditGoal = false;

  goalList = toSignal(this.goalService.goalList$(), { initialValue: [] });

  constructor(
    private goalService: GoalService,
    private resumeService: ResumeService
  ) {}

  onEditGoalClick(data: Goal) {
    this.isEditGoal = true;
    this.selectedGoal = data;
    this.goalSubData = data.subData;
    this.isNewEditGoalVisible = true;
  }

  onNewGoalBtnClick() {
    this.isEditGoal = false;

    this.goalSubData = {
      company: '',
      position: '',
      companyDetails: '',
      jobDescription: '',
    };

    this.isNewEditGoalVisible = true;
  }

  onDeleteGoalClick(i: number) {
    this.goalService.deleteGoalList$([this.goalList()[i]]).pipe(take(1)).subscribe();
  }
}
